import { c as _c } from "react/compiler-runtime";
import './departure-cta.scss';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import type { GraphQLCommitment, GraphQLDeparture, GraphQLDepartureSub } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { DepartureCtaLeaving } from '../departure-cta-leaving/departure-cta-leaving.tsx';
import { DepartureCtaSub } from '../departure-cta-sub/departure-cta-sub.tsx';
export type DepartureCtaProps = {
  departedChild?: GraphQLDeparture['departedChild'];
  departedCommitment?: GraphQLCommitment;
  offeredSub?: GraphQLDepartureSub;
  autoAcceptDate?: string | null;
  showChildDetailsCta?: boolean;
};
export const DepartureCta: React.FC<DepartureCtaProps> = t0 => {
  const $ = _c(14);
  const {
    departedChild,
    departedCommitment,
    offeredSub,
    autoAcceptDate,
    showChildDetailsCta: t1
  } = t0;
  const showChildDetailsCta = t1 === undefined ? true : t1;
  if (!departedChild) {
    return null;
  }
  const departedChildName = (departedChild.displayName ?? "").trim();
  let t2;
  if ($[0] !== offeredSub) {
    t2 = offeredSub ? (offeredSub.child.displayName ?? "").trim() : undefined;
    $[0] = offeredSub;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const offeredSubName = t2;
  const hasOfferedSub = !!offeredSub && !!offeredSubName;
  if (!departedChildName) {
    return null;
  }
  const childGlobalId = departedChild.globalId;
  let t3;
  if ($[2] !== departedChild || $[3] !== departedCommitment || $[4] !== showChildDetailsCta) {
    t3 = <DepartureCtaLeaving child={departedChild} commitment={departedCommitment} showChildDetailsCta={showChildDetailsCta} />;
    $[2] = departedChild;
    $[3] = departedCommitment;
    $[4] = showChildDetailsCta;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== autoAcceptDate || $[7] !== childGlobalId || $[8] !== hasOfferedSub || $[9] !== offeredSub) {
    t4 = hasOfferedSub && offeredSub && <><div aria-hidden="true" className="relative w-full flex justify-center items-center -mt-comfy-xs"><div className="DepartureCta__relationship absolute flex justify-center items-center"><ArkIcon iconName="switch-vertical-02" size="1rem" /></div></div><DepartureCtaSub child={offeredSub.child} departedChildGlobalId={childGlobalId} autoAcceptDate={autoAcceptDate} /></>;
    $[6] = autoAcceptDate;
    $[7] = childGlobalId;
    $[8] = hasOfferedSub;
    $[9] = offeredSub;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <div className="DepartureCta relative flex flex-col gap-comfy-xs">{t3}{t4}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};